import {EntityFilter} from "../baseEntities";

export enum FilterSolicitationSearchFields {
    PageSize = 'intPageSize',
    CurrentPage = 'intActualPage',
    OrderBy = 'vchOrderBy',
    SolicitationId = 'idSolicitud',
    ClientId = 'idCliente',
    BusinessName = 'razonSocial',
    CUIT = 'cuit',
    SolicitationOriginId = 'idSolicitudEnOrigen',
    OperationOriginId = 'idOperacionEnOrigen',
    BankCode = 'codBanco',
    BranchCode = 'codBancoSucursal',
    SolicitationTypeCode = 'codSolicitudTipo',
    SolicitationStateCode = 'codSolicitudEstado',
    CommercialId = 'idComercial',
    RegisterDate = 'fechaAlta',
    SolicitationChannelCode = 'codSolicitudCanal',
    SolicitationTypeListCode = 'codsSolicitudTipo',
    SolicitationStateClassificationListCode = 'codsSolicitudEstadoClasificacion'
}

export interface FilterSolicitationSearch extends EntityFilter {
    [FilterSolicitationSearchFields.SolicitationId]?: number;
    [FilterSolicitationSearchFields.ClientId]?: number;
    [FilterSolicitationSearchFields.BusinessName]?: string;
    [FilterSolicitationSearchFields.CUIT]?: string;
    [FilterSolicitationSearchFields.SolicitationOriginId]?: string;
    [FilterSolicitationSearchFields.OperationOriginId]?: string;
    [FilterSolicitationSearchFields.BankCode]?: number;
    [FilterSolicitationSearchFields.BranchCode]?: number;
    [FilterSolicitationSearchFields.SolicitationTypeCode]?: number;
    [FilterSolicitationSearchFields.SolicitationStateCode]?: number;
    [FilterSolicitationSearchFields.CommercialId]?: number;
    [FilterSolicitationSearchFields.RegisterDate]?: Date;
    [FilterSolicitationSearchFields.SolicitationChannelCode]?: number;
    [FilterSolicitationSearchFields.SolicitationTypeListCode]?: number[];
    [FilterSolicitationSearchFields.SolicitationStateClassificationListCode]?: number[];
}
